// src/routes/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@components/AuthContext';
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

function ProtectedRoute({ allow }) {
  const lang = useLang() 
  const { user, loading, isAuthReady } = useAuth();
  // 또는 isAuthReady 써도 됨: const { loading, isAuthReady } = useAuth();

  // 1) 아직 서버에서 /me 불러오는 중이면 로딩 표시
  if (loading) {
    return <div>로딩중...</div>; // 스피너 컴포넌트 있으면 그걸 써도 됨
  }

  // 2) 로딩은 끝났는데 로그인 안 돼 있으면 메인 페이지로 이동
  if (!isAuthReady) {
    return <Navigate to={buildLangHref("/", lang)} replace />;
  }

  // allow가 있고 user.class가 그 안에 없으면 거부 - 교수자와 그외 구분시
  if (allow && !allow.includes(user?.clss)) {
    // return <Navigate to="/no-access" replace />;
    return <Navigate to={buildLangHref("/", lang)} replace />;
  }

  // 3) 로그인 되어 있으면 안쪽 라우트(<Outlet />)를 렌더링
  return <Outlet />;
}

export default ProtectedRoute;
